import { LanguageProvider } from './context/LanguageProvider';
import { Navbar } from './components/Navbar';
import { HeroSection } from './components/HeroSection';
import { ExpertiseGrid } from './components/ExpertiseGrid';
import { ServicesSection } from './components/ServicesSection';
import { AboutSection } from './components/AboutSection';
import { TechTrustCards } from './components/TechTrustCards';
import { PortfolioSection } from './components/PortfolioSection';
import { BeforeAfterSlider } from './components/BeforeAfterSlider';
import { StatsSection } from './components/StatsSection';
import { WorkflowSection } from './components/WorkflowSection';
import { TestimonialsSection } from './components/TestimonialsSection';
import { ContactSection } from './components/ContactSection';
import { Footer } from './components/Footer';
import { ScrollToTop } from './components/ScrollToTop';

function App() {
  return (
    <LanguageProvider>
      <div className="min-h-screen bg-vilarias-black text-white">
        <Navbar />
        <main>
          <HeroSection />
          <ExpertiseGrid />
          <ServicesSection />
          <AboutSection />
          <TechTrustCards />
          <PortfolioSection />
          <BeforeAfterSlider />
          <StatsSection />
          <WorkflowSection />
          <TestimonialsSection />
          <ContactSection />
        </main>
        <Footer />
        <ScrollToTop />
      </div>
    </LanguageProvider>
  );
}

export default App;
